import { useToasts } from "app/common/hooks";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";

import { useCrmEnrichmentJobRemoveMutation } from "app/pages/sales-intelligence/modules/crm-enrichment/query/mutations/useCrmEnrichmentJobRemoveMutation";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";
import { salesforceEnrichmentQueryKeys } from "../key-factory";

export default function useSfEnrichmentJobRemoveMutation() {
    const { showSuccessToast } = useToasts();

    return useCrmEnrichmentJobRemoveMutation({
        apiService: sfEnrichmentApiService,
        queryKeys: salesforceEnrichmentQueryKeys,
        onSuccessCallback: (_, job) => {
            showSuccessToast(
                getToastItemComponent({
                    text: translate("si.crm-enrichment.sf.remove-modal.success.toast.named", {
                        jobName: job.name,
                    }),
                }),
            );
        },
    });
}
